import { Link } from 'react-router-dom';
import { styled } from 'styled-components';

import { Col, Container, Row } from 'react-bootstrap';

import poweredByNotable from '../../../../assets/powered-by-notable-logo.png';

const EmbeddedFooter: React.FC = () => {
  return (
    <Container className="pt-4" fluid>
      <StyledRow className="justify-content-between">
        <Col xs="auto" className="d-flex px-0 align-items-end">
          <StyledLink to="/patient-terms-of-use" className="" target="_blank">
            Terms of service
          </StyledLink>
        </Col>
        <Col xs="auto" className="ps-0 pe-1">
          <StyledImg
            alt="Powered by Notable"
            src={poweredByNotable}
            className=""
          />
        </Col>
      </StyledRow>
    </Container>
  );
};

export default EmbeddedFooter;

const StyledLink = styled(Link)`
  color: var(--color-shade-80);
  cursor: pointer;
  font-family: var(--font-family-headline);
  font-size: 0.75rem;
  font-weight: 400;
  text-decoration: none;
`;

const StyledImg = styled.img`
  height: 24px;
  width: auto;
`;

const StyledRow = styled(Row)`
  padding-bottom: 54px;
`;
